class FileDownloadTaskRecordResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 下载时间 */
  downloadTime = "";

  /** 错误信息 */
  errMsg = "";

  /** 文件名称 */
  fileName = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 存储对象链接 */
  ossUrl = "";

  /** 处理时间(毫秒) */
  processingTime = undefined;

  /** 请求body */
  reqBody = "";

  /** 请求方式：GET,HEAD,POST,PUT,PATCH,DELETE,OPTIONS,TRACE */
  reqMethod = "";

  /** 请求下载名称 */
  reqName = "";

  /** 请求下载url */
  reqUrl = "";

  /** 来源应用 */
  sourceAppName = "";

  /** 处理状态 10:处理中 20:处理成功 30:处理失败 40:已下载 */
  status = undefined;

  /** 链路ID */
  traceId = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class FileDownloadTaskRpcRequestDto {
  /** 文件名称 */
  fileName = "";

  /** 文件类型(比如：pdf) 不填默认从应答头取 */
  fileType = "";

  /** 加锁范围 1：接口+当前用户(默认) 2：接口 */
  lockScope = undefined;

  /** 请求下载body */
  reqBody = undefined;

  /** 请求下载头 */
  reqHeaders = undefined;

  /** 请求下载方式：GET,HEAD,POST,PUT,PATCH,DELETE,OPTIONS,TRACE，不填默认是GET */
  reqMethod = "";

  /** 请求下载名称 */
  reqName = "";

  /** 请求下载url */
  reqUrl = "";

  /** 来源应用 */
  sourceAppName = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class ImportTaskRecordCreateRpcRequestDto {
  /** 错误信息 */
  errMsg = "";

  /** id */
  id = undefined;

  /** 是否开启结果通知 */
  resultNotifyFlag = false;

  /** 处理状态 10:处理中 20:处理成功 30:处理失败 */
  status = undefined;
}

class ImportTaskRecordModel {
  /** 应用名称 */
  appName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 错误信息 */
  errMsg = "";

  /** 文件特征 */
  fileMd5 = "";

  /** 文件名称 */
  fileName = "";

  /** id */
  id = undefined;

  /** 接口名称 */
  interfaceName = "";

  /** 接口url */
  interfaceUrl = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 处理时间(毫秒) */
  processingTime = undefined;

  /** 处理状态 10:处理中 20:处理成功 30:处理失败 */
  status = undefined;

  /** 链路ID */
  traceId = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class ImportTaskRecordResponseDto {
  /** 应用名称 */
  appName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 错误信息 */
  errMsg = "";

  /** 文件名称 */
  fileName = "";

  /** id */
  id = undefined;

  /** 接口名称 */
  interfaceName = "";

  /** 接口url */
  interfaceUrl = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 处理时间(毫秒) */
  processingTime = undefined;

  /** 处理状态 10:处理中 20:处理成功 30:处理失败 */
  status = undefined;

  /** 链路ID */
  traceId = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class ReportTaskRecordRequestDto {
  /** 报表名称 */
  reportName = "";

  /** 请求app */
  requestApp = "";

  /** 请求body */
  requestBody = "";

  /** 请求方式：GET,HEAD,POST,PUT,PATCH,DELETE,OPTIONS,TRACE */
  requestMethod = "";

  /** 请求url */
  requestUrl = "";
}

class ReportTaskRecordResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否1:是 */
  deleted = undefined;

  /** 下载时间 */
  downloadTime = "";

  /** 错误信息 */
  errorMessage = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** remark */
  remark = "";

  /** 报表名称 */
  reportName = "";

  /** 报表链接 */
  reportUrl = "";

  /** 请求app */
  requestApp = "";

  /** 请求body */
  requestBody = "";

  /** 请求流水ID */
  requestId = "";

  /** 请求方式：GET,HEAD,POST,PUT,PATCH,DELETE,OPTIONS,TRACE */
  requestMethod = "";

  /** 请求url */
  requestUrl = "";

  /** 请求用户信息 */
  requestUserInfo = "";

  /** 请求状态 10:生成中 20:生成成功 30:生成失败 40:已下载 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class ReportTaskRecordRpcRequestDto {
  /** 下载时间 */
  downloadTime = "";

  /** 错误信息 */
  errorMessage = "";

  /** 行id,判断走更新还是新增的标识 */
  id = undefined;

  /** 收件人用户编码，不填会拿上下文用户，是否推送取决resultNotify */
  recipientCode = "";

  /** 备注 */
  remark = "";

  /** 报表名称 */
  reportName = "";

  /** 报表链接 */
  reportUrl = "";

  /** 请求app */
  requestApp = "";

  /** 请求body */
  requestBody = "";

  /** 请求流水ID */
  requestId = "";

  /** 请求方式：GET,HEAD,POST,PUT,PATCH,DELETE,OPTIONS,TRACE */
  requestMethod = "";

  /** 请求url */
  requestUrl = "";

  /** 请求用户信息 */
  requestUserInfo = "";

  /** 是否开启下载结果通知 */
  resultNotify = false;

  /** 请求状态 10:生成中 20:生成成功 30:生成失败 40:已下载 */
  status = undefined;
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new IPage();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

export const report = {
  FileDownloadTaskRecordResponseDto,
  FileDownloadTaskRpcRequestDto,
  IPage,
  ImportTaskRecordCreateRpcRequestDto,
  ImportTaskRecordModel,
  ImportTaskRecordResponseDto,
  ReportTaskRecordRequestDto,
  ReportTaskRecordResponseDto,
  ReportTaskRecordRpcRequestDto,
  Response,
  ResponseDto,
};
